// Textos de la cabecera y del pie de la sección «la app por dentro», literales de los tableros
// Seccion_Mockups y Seccion_Mockups_Movil (D-22). Los textos de cada pantalla viven en
// src/content/pantallasApp.ts, que comparten las pestañas y el carrusel.

export const TEXTOS_SECCION_MOCKUPS = {
    antetitulo: 'Así es TherapyRecap 2.0 por dentro',
    tituloInicio: 'Todo el caso de tu paciente, ',
    tituloResaltado: 'en un solo sitio.',
    entradillaEscritorio:
        'Estas son las pantallas reales de la app, con una paciente de ejemplo. Elige una para ver qué hace.',
    // El tablero móvil acorta la entradilla: solo existe en el árbol móvil.
    entradillaMovil: 'Pantallas reales de la app, con una paciente de ejemplo.',
    etiquetaLista: 'Pantallas de la app',
    etiquetaFijate: 'Fíjate',
    leyenda: 'Paciente de ejemplo · datos ficticios',
    cta: 'Pruébalo con tus pacientes',
    hrefCta: '/app/register',
    anterior: 'Pantalla anterior',
    siguiente: 'Pantalla siguiente',
} as const;

/** «Pantalla 4 de 7»: lo que anuncia la región viva del carrusel al cambiar de pantalla. */
export function textoPosicion(numero: number, total: number): string {
    return `Pantalla ${numero} de ${total}`;
}
